export const settingsTabMeta = {
  id: "settings",
  label: "Cài đặt",
  shortLabel: "CĐ",
};
